import { Component } from '@angular/core';

@Component({
  selector: 'app-successful-icon',
  templateUrl: './successful-icon.component.html'
})
export class SuccessfulIconComponent {

}
